export const FALLBACK_IMAGE =
  "https://images.unsplash.com/photo-1788077510447-b8825f8472d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjbGF5JTIwcGlnZW9uJTIwc2hvb3RpbmclMjBzcG9ydCUyMGF0aGxldGUlMjBndW4lMjBvdXRkb29yJTIwZmllbGR8ZW58MHx8fHwxNzg4NzEyNTIwfDA&ixlib=rb-4.1.0&q=85";

export function formatDateRange(start, end) {
  if (!end || end === start) return formatDate(start);
  const from = new Date(`${start}T12:00:00`);
  const to = new Date(`${end}T12:00:00`);
  const sameMonth = from.getMonth() === to.getMonth();
  const dayFormat = new Intl.DateTimeFormat("es-ES", { day: "2-digit" });
  const dayMonth = new Intl.DateTimeFormat("es-ES", { day: "2-digit", month: "long" });
  const full = new Intl.DateTimeFormat("es-ES", { day: "2-digit", month: "long", year: "numeric" });
  return sameMonth ? `${dayFormat.format(from)} y ${full.format(to)}` : `${dayMonth.format(from)} – ${full.format(to)}`;
}

export function formatDate(date) {
  if (!date) return "Fecha por confirmar";
  return new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date(`${date}T12:00:00`));
}

export function shortDate(date) {
  if (!date) return "--";
  return new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "short",
  }).format(new Date(`${date}T12:00:00`));
}

export function slugify(value) {
  return String(value || "item")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function parseSeries(value) {
  return String(value || "")
    .split(",")
    .map((item) => Number(item.trim()))
    .filter((item) => Number.isFinite(item));
}

export function csvCell(value) {
  return `"${String(value ?? "").replaceAll('"', '""')}"`;
}
